import React from 'react';

const Footer = () => {
  return (
    <footer className="mt-12 text-center text-gray-500">
      <div className="flex justify-center mb-2">
        <img src={require('../assets/logo.png')} alt="Munorva logo" className="h-6" />
      </div>
      <p>Munorva Technologies Pvt Ltd © {new Date().getFullYear()} All rights reserved</p>
      <p>150, HIMMATGANJ, G T B NAGAR, ALLAHBAD, ALLAHBAD-211016, Uttar Pradesh, India</p>
      <p>Contact: +91 63936 85026 / +91 96827 34000</p>
      <p>Email: info@munorva.com</p>
      <div className="flex justify-center space-x-4 mt-2">
        <a href="mailto:info@munorva.com" className="hover:text-cyan-400">Email</a>
        <a href="#" className="hover:text-cyan-400">LinkedIn</a>
        <a href="#" className="hover:text-cyan-400">Twitter</a>
      </div>
    </footer>
  );
};

export default Footer;
